// extracted by mini-css-extract-plugin
export default {"root":"TariffPeriodSwitch__root--YzGRk","discountLabel":"TariffPeriodSwitch__discountLabel--2Z_-U","darkLabel":"TariffPeriodSwitch__darkLabel--2RPws"};